import { PushModule } from '@rx-angular/template/push';
import { LetModule } from '@rx-angular/template/let';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { RouterModule } from '@angular/router';

import { MaterialModule } from '@app/material';

import { UiModule } from '@app/ui';

import { VideoComponent } from './video/video.component';
import { SearchComponent } from './search/search.component';
import { DetailComponent } from './detail/detail.component';
import { HomeComponent } from './home/home.component';
import { SchoolsComponent } from './schools/schools.component';
import { SchoolComponent } from './school/school.component';
import { NavigationComponent } from './navigation/navigation.component';
import { AboutComponent } from './about/about.component';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    MaterialModule,
    
    UiModule,
    LetModule,
    PushModule,
  ],
  declarations: [
    VideoComponent,
    SearchComponent,
    DetailComponent,
    HomeComponent,
    //DevelopComponent,
    SchoolsComponent,
    SchoolComponent,
    NavigationComponent,
    AboutComponent,
  ],

  exports: [
    VideoComponent,
    SearchComponent,
    DetailComponent,
    HomeComponent,
    //DevelopComponent,
    SchoolsComponent,
    SchoolComponent,
    NavigationComponent,
    AboutComponent,
  ],
})
export class PagesModule {}
